const enum CurrencyCode {
    CAD = "cad",
    USD = "usd",
}

export const enum RegionCode {
    CA = "ca",
    US = "us",
}

export const currencyForRegion: Record<RegionCode, CurrencyCode> = {
    [RegionCode.CA]: CurrencyCode.CAD,
    [RegionCode.US]: CurrencyCode.USD,
};

export const enum CardBrandRepresentation {
    AMEX = "Amex",
    ARGENCARD = "Argencard",
    BANCONTACT_MISTER_CASH = "Bancontact/Mister Cash",
    DE_BIJENKORF_CARD = "de Bijenkorf Card",
    CABAL = "Cabal",
    CARTE_BANCAIRES = "Carte Bancaire",
    CODENSA = "Codensa",
    CHINA_UNION_PAY = "China Union Pay",
    DANKORT = "Dankort",
    DINERS_CLUB = "Diners Club",
    DISCOVER = "Discover",
    ELECTRON = "Electron",
    ELO = "ELO",
    FORBRUGSFORENINGEN = "Forbrugsforeningen",
    HIPER = "HiperCard",
    HIPERCARD = "HiperCard",
    JCB = "JCB",
    KAREN_MILLEN_GIFTCARD = "Karen Millen GiftCard",
    LASER = "Laser",
    MAESTRO = "Maestro",
    MAESTRO_UK = "Maestro UK",
    MASTERCARD = "Mastercard",
    ALPHA_BANK_MASTERCARD_BONUS = "Alpha Bank Mastercard Bonus",
    MIR = "MIR",
    NARANJA = "Naranja",
    OASIS_GIFTCARD = "Oasis GiftCard",
    RUPAY = "RuPay",
    TARJETA_SHOPPING = "Tarjeta Shopping",
    SOLO = "Solo",
    TROY = "Troy",
    UATP = "UATP",
    VISA = "Visa",
    ALPHA_BANK_VISA_BONUS = "Alpha Bank Visa Bonus",
    VISA_DANKORT = "Visa Dankort",
    WAREHOUSE_GIFTCARD = "Warehouse GiftCard",
}
